import { useParams } from 'react-router-dom';

/**
 * A required route parameter, as a string rather than `string | undefined`.
 *
 * `useParams` types every parameter optional because it cannot know the route it was called from, so
 * every page ended up writing `useCampaign(campaignId!)`. The assertion was correct — the router only
 * mounts the page when the segment matched — but it hid the one case where it isn't: a hand-typed or
 * stale URL that reaches the component with the parameter absent. That produced a request to
 * `/campaigns/undefined` and a 404 the user could not interpret.
 *
 * Throwing instead sends it to the nearest error boundary, and does so BEFORE any query is issued.
 */
export function useRouteParam(name: string): string {
  const parameters = useParams();
  const value = parameters[name];

  if (value === undefined || value === '') {
    throw new Error(`This page needs a ${name} in its address, and the address does not have one.`);
  }

  return value;
}
